(() => {
  'use strict';
  const configElement = document.getElementById('DonglinEnquiryConfig');
  if (!configElement || configElement.dataset.initialised) return;
  configElement.dataset.initialised = 'true';
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const root = (config.root || '/').replace(/\/$/, '');
  const localize = value => `${root}${value}`;
  const stripRoot = value => root && value.startsWith(`${root}/`) ? value.slice(root.length) : value;
  const contactPath = '/pages/contact';
  const russian = config.locale === 'ru';
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object || {}, key);
  const knownTopic = value => own(config.pages, value) && own(config.text, value);
  const knownProduct = handle => own(config.products, handle) ? config.products[handle] : null;
  const path = stripRoot(location.pathname.replace(/\/$/, ''));
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value);
  const cleanSource = value => {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol)) return '';
      const page = stripRoot(url.pathname.replace(/\/$/, ''));
      if (page === contactPath || /^\/(account|cart|checkout|checkouts|admin)(\/|$)/.test(page)) return '';
      url.search = '';
      url.hash = '';
      return url.href;
    } catch { return ''; }
  };
  const productHandle = url => {
    try {
      const parsed = new URL(url, location.origin);
      if (parsed.origin !== location.origin) return '';
      const match = parsed.pathname.match(/\/products\/([a-z0-9-]+)\/?$/);
      return match && validHandle(match[1]) ? match[1] : '';
    } catch { return ''; }
  };

  if (path !== contactPath) {
    const decorate = link => {
      let destination;
      try { destination = new URL(link.href, location.origin); } catch { return; }
      if (destination.origin !== location.origin || stripRoot(destination.pathname.replace(/\/$/, '')) !== contactPath) return;
      let handle = destination.searchParams.get('product');
      if (!validHandle(handle)) handle = '';
      if (!handle) {
        const card = link.closest('product-card');
        const productLink = card?.querySelector('a[href*="/products/"]');
        handle = productLink ? productHandle(productLink.href) : '';
      }
      if (!handle && validHandle(config.currentProduct)) handle = config.currentProduct;
      destination.pathname = localize(contactPath);
      let topic = 'general';
      if (russian) {
        const product = knownProduct(handle);
        const requested = destination.searchParams.get('enquiry');
        topic = product?.topic || Object.keys(config.pages || {}).find(key => config.pages[key] === path) || (knownTopic(requested) ? requested : 'general');
      }
      destination.searchParams.set('enquiry', topic);
      destination.searchParams.set('source', cleanSource(location.href));
      if (handle) destination.searchParams.set('product', handle);
      else destination.searchParams.delete('product');
      destination.hash = 'DonglinContactStart';
      if (link.href !== destination.href) link.href = destination.href;
    };
    const decorateAll = () => document.querySelectorAll('a[href]').forEach(decorate);
    decorateAll();
    document.addEventListener('click', event => {
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (link) decorate(link);
    }, true);
    new MutationObserver(records => {
      if (records.some(record => record.addedNodes.length)) decorateAll();
    }).observe(document.body, { childList: true, subtree: true });
    return;
  }

  const parameters = new URLSearchParams(location.search);
  const topic = parameters.get('enquiry');
  const legacyPage = Object.prototype.hasOwnProperty.call(config.pages || {}, topic) ? config.pages[topic] : '';
  const source = cleanSource(parameters.get('source')) || (legacyPage ? cleanSource(localize(legacyPage)) : '');
  if (!source) return;
  const field = document.querySelector('main form textarea[name="contact[body]"]');
  const form = field?.form;
  if (!form || field.value.trim() || form.querySelector('.contact-form__success, .contact-form__error')) return;
  let handle = parameters.get('product');
  if (!validHandle(handle)) handle = productHandle(source);
  const productURL = handle ? new URL(localize(`/products/${handle}`), location.origin).href : '';
  field.value = config.text.confirmation;
  field.dispatchEvent(new Event('input', { bubbles: true }));
  const productField = form.querySelector('input[name="contact[Product or collection]"]');
  if (productField && !productField.value.trim()) {
    productField.value = productURL || source;
    productField.dispatchEvent(new Event('input', { bubbles: true }));
  }
  const notice = document.createElement('p');
  notice.id = 'DonglinEnquiryNotice';
  notice.textContent = config.text.notice;
  notice.style.marginBlock = '0';
  notice.style.color = 'var(--color-input-text)';
  notice.style.textAlign = 'start';
  field.before(notice);
  field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), notice.id].filter(Boolean).join(' '));
})();



